import React from "react";
import '../print.css';
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';
import { upperCase } from "lodash";

export default class ComponentToPrint extends React.Component {
  render() {
    const { supplierData, searchData, selectedNewYear, selectedNewMonth, selectedRoute } = this.props;

    return (
      <div>
        <h2 style={{ textAlign: "center", textDecoration: "underline" }}>Balance Payment List Report</h2>
        <div>&nbsp;</div>
        <h2 style={{ textAlign: "center" }}>BOUGHT LEAF BALANCE PAYMENT CHECKLIST FOR THE MONTH OF {upperCase(selectedNewMonth)} - {selectedNewYear}</h2>
        <div style={{ margin: "20px 0" }}>
          <h2 style={{ textAlign: "center" }}>Group: {searchData.groupName} </h2>
          <h2 style={{ textAlign: "center" }}>Factory: {searchData.factoryName} </h2>
          <h2 style={{ textAlign: "center" }}>Route: {selectedRoute == undefined ? "All Routes" : selectedRoute} </h2>
        </div>


        <Box minWidth={1050} ml={2} mr={10} width="70%" style={{ margin: "20px auto" }}>
          <TableContainer>
            <Table aria-label="balance-payment-table">
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ border: "0.5px solid grey" }}>Registration Number</TableCell>
                  <TableCell align="center" style={{ border: "0.5px solid grey" }}>First Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {supplierData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align="left" style={{ border: "0.5px solid grey" }}>
                      {data.registrationNumber}
                    </TableCell>
                    <TableCell align="left" style={{ border: "0.5px solid grey" }}>
                      {data.firstName}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <h4 style={{ textAlign: "center", marginTop: "30px" }}>******* End of List *******</h4>
      </div>
    );
  }
}
